<template>
  <!-- eslint-disable max-len -->
  <el-dialog
    :title="(item.ID ? '编辑' : '新增') + '服务器'"
    :visible="visible"
    @close="onClose"
    @open="onOpen"
    width="30%"
    top="10vh"
    :close-on-click-modal="false"
  >
    <el-form :model="item" ref="itemform" label-width="120px" :rules="rules">
      <el-form-item label="服务器类型" prop="ServerTypeID">
        <select2
          style="width: 100%"
          v-model="item.ServerTypeID"
          url="basic?type=ServerType"
          :clearable="false"
          placeholder="请选择服务器类型"
          noDataText="无类型"
          :emptyValue="0"
          :currentList="currentServerType"
        ></select2>
      </el-form-item>
      <el-form-item label="远程方式" prop="MannerID">
        <select2
          style="width: 100%"
          v-model="item.MannerID"
          url="basic?type=Manner"
          :clearable="false"
          placeholder="请选择远程方式"
          noDataText="无类型"
          :emptyValue="0"
          :currentList="currentManner"
        ></select2>
      </el-form-item>
      <el-form-item label="远程工具账号" prop="RemoteAccount">
        <el-input
          v-model.trim="item.RemoteAccount"
          placeholder="请输入远程工具账号"
        ></el-input>
      </el-form-item>
      <el-form-item label="远程工具密码" prop="RemotePassword">
        <el-input
          v-model.trim="item.RemotePassword"
          placeholder="请输入远程工具密码"
        ></el-input>
      </el-form-item>
      <el-form-item label="服务器用户名" prop="ServerUsername">
        <el-input
          v-model.trim="item.ServerUsername"
          placeholder="请输入服务器用户名"
        ></el-input>
      </el-form-item>
      <el-form-item label="服务器密码" prop="ServerPassword">
        <el-input
          v-model.trim="item.ServerPassword"
          placeholder="请输入服务器密码"
        ></el-input>
      </el-form-item>
      <el-form-item label="通讯协议" prop="CommProtocolID">
        <select2
          style="width: 100%"
          v-model="item.CommProtocolID"
          url="basic?type=CommProtocol"
          :clearable="false"
          placeholder="请选择通讯协议"
          noDataText="无通讯协议"
          :emptyValue="0"
          :currentList="currentCommProtocol"
        ></select2>
      </el-form-item>
      <el-form-item label="IP地址" prop="IP">
        <el-input v-model.trim="item.IP" placeholder="请输入IP地址"></el-input>
      </el-form-item>
      <el-form-item label="端口号" prop="Port">
        <el-input
          v-model.trim="item.Port"
          placeholder="请输入端口号"
        ></el-input>
      </el-form-item>
      <el-form-item label="所属平台" prop="PlatformID">
        <select2
          style="width: 100%"
          v-model="item.PlatformID"
          url="platform"
          labelName="PlatformName"
          :clearable="false"
          :currentList="currentPlatform"
          placeholder="请选择平台"
          no-data-text="无平台"
          :emptyValue="0"
        ></select2>
      </el-form-item>
      <el-form-item label="备注" prop="Remark">
        <el-input
          type="textarea"
          v-model.trim="item.Remark"
          :autosize="{ minRows: 2 }"
          placeholder="请输入备注"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="onClose">
        <i class="fas fa-times"></i> 取 消
      </el-button>
      <el-button type="primary" @click="onSubmit" :disabled="submitting">
        <i class="far fa-save"></i> 确 定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    value: Object,
    visible: Boolean,
    deviceList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    const validateIP = (rule, value, callback) => {
      if (
        value &&
        !value.match(
          // eslint-disable-next-line max-len
          /(?=(\b|\D))(((\d{1,2})|(1\d{1,2})|(2[0-4]\d)|(25[0-5]))\.){3}((\d{1,2})|(1\d{1,2})|(2[0-4]\d)|(25[0-5]))(?=(\b|\D))/
        )
      ) {
        callback(new Error("请输入正确的IP地址"));
      } else {
        callback();
      }
    };
    const validatePort = (rule, value, callback) => {
      if (value && !value.match(/^\d{1,5}$/)) {
        callback(new Error("请输入正确的端口号"));
      } else {
        callback();
      }
    };
    return {
      item: {},
      rules: {
        ServerTypeID: [
          { required: true, message: "服务器类型不能为空", trigger: "blur" },
        ],
        MannerID: [{ required: true, message: "远程方式不能为空", trigger: "blur" }],
        PlatformID: [
          { required: true, message: "平台不能为空", trigger: "blur" },
        ],
        IP: [
          { required: true, message: "IP地址不能为空", trigger: "blur" },
          { validator: validateIP, trigger: "blur" },
        ],
        Port: [
          { required: true, message: "端口号不能为空", trigger: "blur" },
          { validator: validatePort, trigger: "blur" },
        ],
      },
      submitting: false,
      currentPlatform: [], // 当前平台
      currentServerType: [], // 当前服务器类型
      currentManner: [], // 当前远程方式
      currentCommProtocol: [],
    };
  },
  computed: {
    token() {
      return this.$store.state.auth.token;
    },
  },
  created() {},
  methods: {
    onOpen() {
      this.item = _.clone(this.value);
      if (this.value.ID) {
        this.currentPlatform = [
          {
            ID: this.value.PlatformID,
            PlatformName: this.value.Platform.PlatformName,
          },
        ];
        this.currentServerType = [
          { ID: this.value.ServerTypeID, Name: this.value.ServerType.Name },
        ];
        this.currentManner = [
          { ID: this.value.MannerID, Name: this.value.Manner.Name },
        ];
        this.currentCommProtocol = [
          {
            ID: this.value.CommProtocolID,
            Name: this.value.CommProtocol ? this.value.CommProtocol.Name : "",
          },
        ];
      }
    },
    onClose() {
      this.$emit("update:visible", false);
      this.$emit("cancel");
      this.$refs.itemform.resetFields();
    },
    onSubmit() {
      this.$refs.itemform.validate((valid) => {
        if (!valid) {
          return;
        }
        this.submitting = true;
        this.$emit("input", this.item);
        const itemData = { ...this.item };
        // 保存的操作
        this.$axios
          .request({
            url: this.item.ID
              ? `platformserver/${itemData.ID}`
              : "platformserver",
            method: itemData.ID ? "put" : "post",
            data: itemData,
          })
          .then(() => {
            this.$message.success(itemData.ID ? "编辑成功" : "新增成功");
            this.submitting = false;
            this.$emit(itemData.ID ? "form:updated" : "form:created", true);
            this.$emit("form:saved", true);
            this.$emit("update:visible", false);
          })
          .catch(({ response }) => {
            this.$sys.alarmResponse(response);
            this.submitting = false;
            this.$emit(itemData.ID ? "form:updated" : "form:created", false);
            this.$emit("form:saved", false);
          });
      });
    },
  },
};
</script>
